import React from 'react';
import classNames from 'classnames';

interface IProps {
  text?: string;
  score?: number;
  type?: 'correct' | 'wrong' | 'percent';
}

export const ScoreCard: React.FC<IProps> = ({ type, score, text }) => (
  <div className="h-18 flex w-40 flex-col items-center justify-center rounded-xl bg-white">
    <p
      className={classNames('text-xl font-semibold', {
        'text-green-500': type === 'correct',
        'text-red-500': type === 'wrong',
        'text-black': type === 'percent'
      })}
    >
      {score} {type === 'percent' ? '%' : ''}
    </p>
    <div>
      <span className="text-[0.8rem] font-medium text-gray-400">{text}</span>
    </div>
  </div>
);